import { render } from "./BathIcon.vue?vue&type=template&id=fc57024c"
import script from "./BathIcon.vue?vue&type=script&lang=js"
export * from "./BathIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__